import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

import DplPicker, { dplOptionShape } from '../../components/DplPicker';
import LoadingRow from '../../components/LoadingRow';
import { DPL_OPTIONS_STATUS, DPL_STATUS_NOTICE } from '../../hooks/useDplOptions';
import texts from '../../texts.json';

const BlastDplField = ({
  options, status, value, onChange,
}) => {
  const notice = DPL_STATUS_NOTICE[status];

  const renderControl = () => {
    if (status === DPL_OPTIONS_STATUS.LOADING) {
      return <LoadingRow label={notice.title} />;
    }
    if (notice) {
      return (
        <Typography variant="caption" color="text.secondary">
          {notice.title}
        </Typography>
      );
    }
    return (
      <DplPicker
        options={options}
        value={value}
        onChange={onChange}
      />
    );
  };

  return (
    <Stack spacing={0.75} sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        {texts.sections.dpl.title}
      </Typography>
      {renderControl()}
    </Stack>
  );
};

BlastDplField.propTypes = {
  options: PropTypes.arrayOf(dplOptionShape).isRequired,
  status: PropTypes.oneOf(Object.values(DPL_OPTIONS_STATUS)).isRequired,
  value: dplOptionShape,
  onChange: PropTypes.func.isRequired,
};

BlastDplField.defaultProps = {
  value: null,
};

export default BlastDplField;
